<template>
  <div class="totalbox">
    <div class="listbox">
      <div class="row total">
        <p class="label" style="align-self: center">{{ 'Passengers Info' }}</p>
        <p class="contxt childcenter">
          {{ persons }}
          {{ persons > 1 ? ' Passengers' : 'Passenger' }}
        </p>
      </div>
    </div>
    <template v-for="(rm, index) in roomlist" :key="'room-' + index">
      <template v-for="(item, idx) in rm.Adultslist" :key="'adult-' + index + '-' + idx + '-' + (item?.travelerUid ?? '')">
        <div class="listbox" v-if="shouldRenderTraveler(item)">
          <div class="row total">
            <p class="label username" style="align-self: center">
              {{ travelerDisplayName(item) }}
            </p>
            <p class="contxt childcenter" @click="toggleCollapse(index, idx, 1)">
              <ArrowUpBold class="arrow" v-if="expandedKey === travelerKey(index, idx, 1)" />
              <ArrowDownBold class="arrow" v-else />
            </p>
          </div>
          <div class="row">
            <div class="flexdiv" style="width: 100%; display: flex">
              <span>Adult</span>
              <span>{{ getGender(item.Gender) }}</span>
              <span>{{ safeFlyWeekMDate(item.Birthday) }}</span>
            </div>
          </div>

          <template
            class="listbox"
            v-if="notEmpty(item) && expandedKey === travelerKey(index, idx, 1)"
          >
            <div class="row">
              <p class="label">Passport number</p>
              <p class="contxt childcenter">{{ item.PassportNo }}</p>
            </div>

            <div class="row">
              <p class="label">Passport Expiration Date</p>
              <p class="contxt childcenter">{{ safeFlyWeekMDate(item.Expireddate) }}</p>
            </div>

            <div class="row">
              <p class="label">Nationality</p>
              <p class="contxt childcenter">{{ getCountry(item.Nationality) }}</p>
            </div>
          </template>
        </div>
      </template>
      <template v-for="(item, idx) in rm.Childlist" :key="'child-' + index + '-' + idx + '-' + (item?.travelerUid ?? '')">
        <div class="listbox" v-if="shouldRenderTraveler(item)">
          <div class="row total">
            <p class="label username" style="align-self: center">
              {{ travelerDisplayName(item) }}
            </p>
            <p class="contxt childcenter" @click="toggleCollapse(index, idx, 2)">
              <ArrowUpBold class="arrow" v-if="expandedKey === travelerKey(index, idx, 2)" />
              <ArrowDownBold class="arrow" v-else />
            </p>
          </div>
          <div class="row">
            <div class="flexdiv" style="width: 100%; display: flex">
              <span>Child</span>
              <span>{{ getGender(item.Gender) }}</span>
              <span>{{ safeFlyWeekMDate(item.Birthday) }}</span>
            </div>
          </div>

          <template v-if="notEmpty(item) && expandedKey === travelerKey(index, idx, 2)">
            <div class="row">
              <p class="label">Passport number</p>
              <p class="contxt childcenter">{{ item.PassportNo }}</p>
            </div>

            <div class="row">
              <p class="label">Passport Expiration Date</p>
              <p class="contxt childcenter">{{ safeFlyWeekMDate(item.Expireddate) }}</p>
            </div>

            <div class="row">
              <p class="label">Nationality</p>
              <p class="contxt childcenter">{{ getCountry(item.Nationality) }}</p>
            </div>
          </template>
        </div>
      </template>
    </template>
    <div class="tipstxt">
      <div class="row">
        <p class="tipstxt">
          <img
            src="/images/icon-9.png"
            class="ico"
            style="
              width: 1.6rem;
              height: 100%;
              position: relative;
              top: 0.3rem;
              cursor: pointer;
              margin-right: 1rem;
            "
            alt=""
          /><b>Travelers names must match passports exactly</b>.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { notEmpty, priceFormat, priceAmount } from '@/utils/tool.js'
import Request from '@/services/Request.ts'
import { ArrowDownBold, ArrowUpBold } from '@element-plus/icons-vue'

export default {
  components: {
    ArrowDownBold,
    ArrowUpBold
  },
  props: ['step', 'roomlist'],
  data() {
    return {
      ismobile: false,
      persons: 0,
      countries: [],
      expandedKey: ''
    }
  },
  watch: {
    roomlist: {
      handler(newValue, oldValue) {
        this.getPax()
        //console.log('------------booking Summary watch here-----',newValue);
      },
      deep: true
    }
  },
  mounted() {
    if (document.documentElement.clientWidth < 750) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
    this.getPax()
    this.initCountry()
  },
  methods: {
    notEmpty(obj) {
      return notEmpty(obj)
    },
    travelerDisplayName(item) {
      const last = String(item?.lastname ?? item?.lastName ?? '').trim()
      const first = String(item?.firstname ?? item?.firstName ?? '').trim()
      const middle = String(item?.middlename ?? item?.middleName ?? '').trim()
      const base = [last, first].filter(Boolean).join(' / ')
      const name = [base, middle].filter(Boolean).join(' ').trim()
      return name || 'Select Travelers'
    },
    shouldRenderTraveler(item) {
      if (!item || typeof item !== 'object') return false
      const hasName =
        String(item?.firstname ?? item?.firstName ?? '').trim() !== '' ||
        String(item?.lastname ?? item?.lastName ?? '').trim() !== ''
      const hasBirthday = String(item?.Birthday ?? item?.birthday ?? '').trim() !== ''
      return hasName || hasBirthday
    },
    getPax() {
      let persons = 0
      //console.log('------------------this.roomlist----------',this.roomlist)
      for (let i in this.roomlist) {
        persons += parseInt(this.roomlist[i].Adults) + parseInt(this.roomlist[i].Child)
      }
      this.persons = persons
    },
    initCountry() {
      new Request().webPost(
        {},
        (res) => {
          //console.log('---country---', res)
          this.countries = res.data
        },
        'product/product_trip/getCountries',
        (err) => {},
        3000,
        3
      )
    },
    getCountry(v) {
      let item = this.countries.find((country) => country.country_id === v)
      return item?.iso_code_2??''
    },
    safeFlyWeekMDate(d, y = 1) {
      const raw = String(d ?? '').trim()
      if (!raw) return ''
      return this.flyWeekMDate(raw, y)
    },
    travelerKey(idx1, idx2, type) {
      return `${type}_${idx1}-${idx2}`
    },
    getGender(val) {
      if (val == 1) return 'Male'
      else if (val == 2) return 'Female'
      else if (val == 0) return 'Unspecified'
      else if (val == 8) return 'Undisclosed'
    },
    flyWeekMDate(d, y = 1) {
      var dt = new Date((notEmpty(d) ? String(d).slice(0, 10) : d) + 'T00:00:01')
      if (Number.isNaN(dt.getTime())) return ''
      var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      /* var formattedDate = weeks[dt.getDay()] + ", " + months[dt.getMonth()] + " " + dt.getDate() + ',' + (y>0?' '+dt
					.getFullYear():''); */
      var formattedDate =
        months[dt.getMonth()] + ' ' + dt.getDate() + ',' + (y > 0 ? ' ' + dt.getFullYear() : '')
      return formattedDate
    },
    toggleCollapse(idx1, idx2, type) {
      const key = this.travelerKey(idx1, idx2, type)
      this.expandedKey = this.expandedKey === key ? '' : key
    }
  }
}
</script>

<style scoped>
.totalbox {
  padding: 0 2.4rem;
  border-radius: 1.2rem;
  margin-bottom: 2.4rem;
  background: #fff;
}
.totalbox .titbox {
  padding-top: 2rem;
  color: #333;
  font-family: Poppins-Bold;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.2rem;
}
.totalbox .infobox {
  padding: 1.6rem 0 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}
.totalbox .infobox .pic {
  width: 8rem;
  height: 7rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0.8rem;
}
.totalbox .infobox .txt {
  width: calc(100% - 9.2rem);
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  text-align: left;
}
.totalbox .listbox {
  padding: 1.2rem 0;
  border-bottom: 1px solid #eaeaea;
}
.totalbox .listbox:last-child {
  border-bottom: 0;
}
.totalbox .listbox .tit {
  font-family: Poppins-Bold;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
  padding: 0.8rem 0;
}
.totalbox .listbox .row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  padding: 0.8rem 0;
}
.totalbox .listbox .row .arrow {
  width: 15px;
  margin-left: 5px;
}
.totalbox .listbox .row.total {
  font-size: 1.6rem;
  font-family: Poppins-Bold;
  font-weight: 700;
}
.totalbox .listbox .row .label {
  color: #666666;
}
.totalbox .listbox .row .label.username {
  max-width: calc(100% - 3.2rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.totalbox .listbox .row .airico {
  width: 2rem;
  display: block;
}
.totalbox .listbox .row.total .label,
.totalbox .listbox .row .label span.black,
.totalbox .listbox .row .contxt {
  color: #333333;
}
.totalbox .listbox .row .flexdiv {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.totalbox .listbox .row .green {
  color: #4f6f52 !important;
}
.tipstxt {
  font-family: Poppins;
  font-weight: 500;
  color: #333;
  font-size: 1.2rem;
  padding: 0.8rem 0;
}
.username {
  font-size: 1.4rem;
}
/* 移动端  */
@media screen and (max-width: 750px) {
  .username {
    font-size: 1.4rem;
  }
}
</style>
